import { useParams } from 'react-router';
import { z } from 'zod';

const useParamsChecked = <S extends z.core.$ZodType>(
  schema: S,
): z.output<S> | null => {
  const params = useParams();

  const result = z.safeParse(schema, params);

  if (result.success) {
    return result.data;
  }

  return null;
};

const zIntId = z.coerce.number<string>().int();
const zTelegramChannelId = z.coerce.number<string>().int().transform(String);
/*
//active account
export const useActiveAccountIdPath = () =>
  useParamsChecked(
    z.object({
      advertiser_account_id: zIntId,
    }),
  )?.advertiser_account_id ?? null;

//new account channel request
export const useNewAccountChannelRequestPath = () =>
  useParamsChecked(
    z.object({
      telegram_channel_id: zTelegramChannelId,
    }),
  );

//active workspace
export const useActiveWdPath = () =>
  useParamsChecked(
    z.object({
      workspace_type: z.enum(['site', 'channel']),
      workspace_id: zIntId,
    }),
  );

//both
export const useActiveAccountIdWdPath = () =>
  useParamsChecked(
    z
      .object({
        advertiser_account_id: zIntId,
        workspace_type: z.enum(['site', 'channel']),
        workspace_id: zIntId,
      })
      .partial(),
  );

//channel request
export const useChannelRequestPath = () =>
  useParamsChecked(
    z.object({
      advertiser_account_id: zIntId,
      telegram_channel_id: zTelegramChannelId,
    }),
  );
*/
export const usePathParams = () =>
  useParamsChecked(
    z
      .object({
        advertiser_account_id: zIntId,
        workspace_type: z.enum(['site', 'channel']),
        workspace_id: zIntId,
        telegram_channel_id: zTelegramChannelId,
      })
      .partial(),
  );
